import { render, staticRenderFns } from "./warranty.vue?vue&type=template&id=06534234&scoped=true"
import script from "./warranty.vue?vue&type=script&lang=js"
export * from "./warranty.vue?vue&type=script&lang=js"
import style0 from "./warranty.vue?vue&type=style&index=0&id=06534234&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06534234",
  null
  
)

export default component.exports